import { render, staticRenderFns } from "./UiIconControl.vue?vue&type=template&id=cb19c9bc"
import script from "./UiIconControl.vue?vue&type=script&lang=js"
export * from "./UiIconControl.vue?vue&type=script&lang=js"
import style0 from "./UiIconControl.vue?vue&type=style&index=0&id=cb19c9bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports